import React from 'react'
import './style.scss'
import TestimonialItem from './TestimonialItem';
import {Swiper, SwiperSlide} from 'swiper/react';

import 'swiper/css';
import {SwiperOptions} from "swiper";
import ControlNav from "../slider-portfolio/ControlNav";
import {dsnCN} from "../../hooks/helper";

const TestimonialDetails = [
    {
        name: "Jeanette Williams",
        label: "Harvest Medicine",
        src: "assets/img/avatar/1.jpg",
        description: `"Devlift is a dynamic company with exceptional staff. Each team member that we worked with was friendly, personable, and very reasonable. They listened to us, helped us, developed for us and delivered for us! When given the freedom to create, their creative talents always impressed -just ask for Leah!  The amazing team at Devlift helped us improve & re-launch our website, resulting in a more engaged audience including an overall better user experience not to mention dropping our bounce rate by 68%! Website design, development, and deployment are only small fragments from of their many areas multi-media expertise which could help your company grow too. This company is worth exploring for your needs."`,
      },
      {
        name: "Scott Gauvreau",
        label: "Match Marketing",
        src: "assets/img/avatar/2.jpg",
        description: `"My former agency leaned on Devlift for several web-based media programs and we were continuously blown away with not only the final product, but how responsive, professional, and genuinely great to deal with each member of their team is.  They were very flexible in working under tight timelines, and the final product was always well received by our clients.  If you're looking for a media partner for any of your marketing executions, I'd highly recommend reaching out to Will Graham and his team at Devlift, as I have no doubt you'll be in excellent hands to deliver a top quality execution."`,
      },
      {
        name: "Steve Goldby",
        label: "LeefTail Marketing",
        src: "assets/img/avatar/3.jpg",
        description: `"Will from Devlift was key to helping us get our website up and running, while we got our business up and running. He was very informative and super easy to deal with. Any future questions or assistance we needed he was only ever an email away!
            'Dev'initely recommend Devlift."`,
      },
      {
        name: "Mark Mikulec",
        label: "Mikutech",
        src: "assets/img/avatar/4.jpg",
        description: `"I've partnered with Will and his team at DevLift on several projects, and one thing's for sure - he always puts his customers first.
            His level of professionalism is far above what is standard for the digital media industry. If there's an opportunity for a client referral, I always send them to DevLift Media first, because I know the client will be taken care of, and they'll be very satisfied in the end!"`,
      },
      {
        name: "Jeanette Chong",
        label: "Canadian Bookkeeping Services",
        src: "assets/img/avatar/4.jpg",
        description: `"Devlift Media redid my website that was in bad need of revamping. Throughout it all they were there to help and offer opinions when unsure of which way to go and what to choose.  Everything was done in a professional manner and looks so much better than before. When in the field of doing Accounting & Taxes a professional looking website is a must.  That is exactly what I got in return. I highly recommend using Devlift Media."`,
      },
      {
        name: "E T",
        label: "Rain43 Marketing",
        src: "assets/img/avatar/4.jpg",
        description: `"Using Devlift was a very pleasant experience. They met all of the proposed timelines and produced an exceptional product. These guys are very in-tuned with the latest digital and social platforms/technology. Highly recommended!"`,
      },
      {
        name: "Paull Peterson",
        label: "Toronto Realty Boutique",
        src: "assets/img/avatar/4.jpg",
        description: `"Over the last 8 years I have had the pleasure working with Will Graham to develop several new websites, mobile/tablet applications, branding solutions for businesses and entrepreneurs.
    
            Will and his team utilize the latest in smart technology to create their websites and applications.  All of these projects were completed on time and on budget. Great Job!!  I continue to use Will and his team to deliver products far beyond my expectations. This highly experienced team has expert platform admin training and online consulting .  I not only have full control of my website,  I now manage the content on all websites, they made it so easy.
            
            When you need a fully functioning website with branding that gets attention, this is definitely the team! Will ensures quality at every step, he walked me through the whole process and made this whole experience very comfortable"`,
      },
      {
        name: "Matthew Patterson",
        label: "VIVO Cannabis",
        src: "assets/img/avatar/4.jpg",
        description: `"The DevLift team are great to work with, deliver quality consistently, and are experts in their field! Highly recommend."`,
      },
      {
        name: "Grishanth Ram",
        label: "InMedic Pain Management",
        src: "assets/img/avatar/4.jpg",
        description: `"Will and his team restored my faith in humanity - these guys are top notch developers who take their accountability and work seriously, and more so to heart. Will is always available and always finds creative ways to ensure the job is done right!"`,
      },
      {
        name: "Paul Corsi",
        label: "Corsi Realty",
        src: "assets/img/avatar/4.jpg",
        description: `"I highly recommend Devlift!  Professional, creative and committed to the success of my project."`,
      },
     
]


function TestimonialTow({className, ...restProps}: SwiperOptions) {
    return (

        <section className={dsnCN('dsn-testimonial testimonial-tow', className)}>
            <div className="testimonial-inner">
                <div className='content-box'>
                    <Swiper slidesPerView={1} {...restProps} >
                        {TestimonialDetails.map(
                            (item, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <TestimonialItem
                                            authorName={item.name} label={item.label}
                                            description={item.description}/>
                                    </SwiperSlide>
                                );
                            }
                        )}
                        <ControlNav/>

                    </Swiper>
                </div>
            </div>
        </section>

    )
}


export default TestimonialTow;